import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type RoadVisionCredTypes, roadVision } from '../standards.js'

export type agceCredType = RoadVisionCredTypes
export const agceDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const agce: CarrierDef<agceCredType> = {
  name: 'ACI Motor Freight',
  scac: 'agce',
  ...roadVision,
  engineLayers: [
    'rating',
    'pickup',
    'profinder',
    'documents',
    'tracking',
    'invoice',
  ],
  documentTypes: agceDocumentTypes,
}
